import { IconButton, Image, Stack, StackDivider, StackProps, Tooltip } from "@chakra-ui/react";
import { FaPowerOff } from "react-icons/fa";
import Logo from '../../assets/images/logo.png'


import { Link as ReactLink } from 'react-router-dom';
import { useEffect, useState } from "react";
import { InternalSidebarItemType, DataEntryLinks, SupervisorLinks } from "../../routes/InternalLinks";
import { useSelector } from "react-redux";


export default function InternalSidebar(props: StackProps) {
    const user = useSelector((state: any) => state.user.value);
    // const dispatch = useDispatch();

    const [sidebarItems, setSidebarItems] = useState<InternalSidebarItemType[]>([]);

    useEffect(() => {
        if (user) {
            setSidebarItems(
                (user.role === 'dataentry' ? DataEntryLinks : SupervisorLinks).map((sidebarItem: InternalSidebarItemType) => {
                    sidebarItem.selected = false;
                    if (sidebarItem.link === window.location.pathname) sidebarItem.selected = true;
                    return sidebarItem;
                })
            );
        }
    }, [user]);

    // function Logout() {
    //     dispatch(logout())
    // }

    return (
        <Stack
            w={'6vw'}
            transition={'width 1s'}
            p={4}
            overflowY={'hidden'}
            {...props}
            spacing={6}
            divider={<StackDivider />}
            justify={"center"}
            align={"center"}
            boxShadow={'0px 0px 6px 0px rgba(0,0,0,0.2)'}
            overflowX={'hidden'}
            bg={'primary.400'}
        >
            <Stack
                w={'full'}
                justify={'center'}
                align={"center"}
                spacing={4}
            >
                <Image
                    src={Logo}
                    w={'100%'}
                    draggable={'false'}
                    rounded={'full'}
                    transition={'width 1s'}
                />
            </Stack>
            <Stack h={'full'} py={2} overflowY={'hidden'}>
                {
                    sidebarItems.filter(x => !x.hide).map((sidebarItem,index) => (
                        <Tooltip
                            hasArrow
                            key={'Tooltip' + index.toString()}
                            rounded={'base'}
                            bg={'primary.600'}
                            boxShadow={'base'}
                            placement={'right'}
                            label={sidebarItem.tooltipText}
                            py={2}
                        >
                            {
                                (sidebarItem.tooltipText && sidebarItem.Icon) &&
                                (
                                    <IconButton
                                        key={'IconButton' + index.toString()}
                                        aria-label={sidebarItem.tooltipText}
                                        icon={<sidebarItem.Icon transform="scale(2)" />}
                                        w={'72.5px'}
                                        h={'50px'}
                                        rounded={'none'}
                                        bg={sidebarItem.selected ? 'white' : 'rgba(0,0,0,0.1)'}
                                        color={sidebarItem.selected ? 'primary.400' : 'white'}
                                        _hover={{ bg: sidebarItem.selected ? 'whiteAlpha.900' : 'rgba(0,0,0,0.2)' }}
                                        _active={{ bg: sidebarItem.selected ? 'whiteAlpha.900' : 'rgba(0,0,0,0.4)' }}
                                        as={ReactLink}
                                        to={sidebarItem.link}
                                    />
                                )
                            }
                        </Tooltip>
                    ))
                }
                <Tooltip
                    hasArrow
                    rounded={'base'}
                    bg={'primary.600'}
                    boxShadow={'base'}
                    placement={'right'}
                    label={"Logout"}
                    py={2}
                >
                    <IconButton
                        aria-label="Logout"
                        icon={<FaPowerOff transform="scale(2)" />}
                        w={'72.5px'}
                        h={'50px'}
                        rounded={'none'}
                        bg={'rgba(0,0,0,0.1)'}
                        color={'white'}
                        _hover={{ bg: 'rgba(0,0,0,0.2)' }}
                        as={ReactLink}
                        to={'/logout'}
                        // onClick={Logout}
                    />
                </Tooltip>
            </Stack>
        </Stack>
    )
}